class RemoveLineItem extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.addEventListener('click', this.handleLineItem);
    }
  
    async handleLineItem() {
      const lineItemKey = this.getAttribute('data-line-item-key');
      this.closest("[js-cart-item]").classList.add("is-loading");
  
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineItemKey,
            quantity: 0,
          }),
        });
  
        if (!response.ok) {
          throw new Error('Failed to remove the item from the cart.');
        }
  
        await response.json();
        document.dispatchEvent(new CustomEvent('cart:build')); 
      } catch (error) {
        console.error(error.message);
      }
    }
}
  
customElements.define('remove-line-item', RemoveLineItem);
  
class LineItemOption extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dropdownBtn = this.querySelector('[js-dropdown-btn]');
    this.dropdownPanel = this.querySelector('[js-dropdown-panel]');

    if (!this.dropdownBtn || !this.dropdownPanel) {
      return;
    }

    this.dropdownBtn.addEventListener('click', this.toggleDropdown.bind(this));

    const options = this.dropdownPanel.querySelectorAll('[js-option-item]');
    options.forEach(option => {
      option.addEventListener('click', this.handleLineItem.bind(this));
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.classList.remove('is-open');
      }
    });
  }

  toggleDropdown() {
    this.classList.toggle('is-open');
  }

  async handleLineItem(event) {
    
    const target = event.currentTarget;
    const lineItemKey = target.getAttribute("data-line-item-key");
    const quantity = target.getAttribute("data-quantity");
    const variantId = target.getAttribute("data-variant-id");
  
    if (!lineItemKey) return;
  
    const cartItem = this.closest("[js-cart-item]");
    cartItem?.classList.add("is-loading");
    this.toggleDropdown();
  
    try {
      let response;
  
      if (this.getAttribute("is") === "size-option") {
        response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineItemKey,
            quantity: 0,
          }),
        });
  
        if (!response.ok) {
          throw new Error('Failed to remove the old item.');
        }
  
        response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity
          }),
        });
  
        if (!response.ok) {
          throw new Error('Failed to add the new variant.');
        }
      } else {
        response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineItemKey,
            quantity
          }),
        });
  
        if (!response.ok) {
          throw new Error('Failed to update the cart.');
        }
      }
  
      await response.json();
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (error) {
      console.error('Error handling line item:', error.message);
    }
  }  
}

customElements.define('line-item-option', LineItemOption);

class AddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleAddToCart.bind(this));
  }

  async handleAddToCart(event) {
    event.preventDefault();

    const variantId = this.getAttribute("data-variant-id");

    if (!variantId) return;
    this.classList.add('is-loading');

    try {
      let data;
      if(this.getAttribute("is") === "gift") {
        data = {
          id: variantId,
          quantity: 1,
          properties: {
            _freeGift: true
          }
        } 
      }else {
        data = {
          id: variantId,
          quantity: 1,
          properties: {
            Upsell: true
          }
        } 
      };
      if(this.getAttribute("is") === "addonproduct") {
        data = {
          id: variantId,
          quantity: 1,
          properties: {
            _addonproduct: true
          }
        } 
      }
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error('Failed to add product to the cart.');
      }

      await response.json();
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.querySelector('exclusive-deal-popup.is-open')?.close();
    } catch (error) {
      console.error(error.message);
    } finally {
       this.classList.add('disabled');
    }
  }
}

customElements.define('add-to-cart', AddToCart);

class CouponModalTrigger extends HTMLElement {
  constructor() {
    super();
    this.modal = document.querySelector('[js-coupon-modal]');
    this.closeBtn = this.modal ? this.modal.querySelector('[js-close-modal-btn]') : null;
  }

  connectedCallback() {
    if (!this.modal || !this.closeBtn) return;

    this.addEventListener('click', this.triggerModal.bind(this));
    this.closeBtn.addEventListener('click', this.closeModal.bind(this));
    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  triggerModal(event) {
    event.stopPropagation();
    this.modal.classList.add('is-open');
  }

  closeModal(event) {
    event.stopPropagation();
    this.modal.classList.remove('is-open');
  }

  handleOutsideClick(event) {
    if (!this.modal.contains(event.target) && this.modal.classList.contains('is-open')) {
      this.modal.classList.remove('is-open');
    }
  }
}

customElements.define('coupon-modal-trigger-btn', CouponModalTrigger);

const cartDrawer = document.querySelector("#CartDrawer");
if (cartDrawer) {
  const removeProductFromCart = async (key) => {
    const cartItem = cartDrawer.querySelector(`[js-cart-item][data-key="${key}"]`);
    cartItem?.classList.add("is-loading");

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: 0
      }),
    });

    await response.json();
    document.dispatchEvent(new CustomEvent('cart:build'));
  };

  const checkGiftProducts = () => {
    const progressBar = cartDrawer.querySelector("[js-progress-bar]");

    if (!progressBar) return;

    const gift1Threshold = parseFloat(progressBar.getAttribute("data-gift-1-threshold"));
    const gift2Threshold = parseFloat(progressBar.getAttribute("data-gift-2-threshold"));
    const gift3Threshold = parseFloat(progressBar.getAttribute("data-gift-3-threshold"));
    const gift1Exist = progressBar.getAttribute("data-gift-1-exist") === "true";
    const gift1Key = progressBar.getAttribute("data-gift-1-key");
    const gift2Exist = progressBar.getAttribute("data-gift-2-exist") === "true";
    const gift2Key = progressBar.getAttribute("data-gift-2-key");
    const gift3Exist = progressBar.getAttribute("data-gift-3-exist") === "true";
    const gift3Key = progressBar.getAttribute("data-gift-3-key");
    const cartTotal = parseFloat(progressBar.getAttribute("data-cart-total"));
    console.log(gift1Exist,gift2Exist,gift3Exist);
    if (cartTotal < gift1Threshold && gift1Exist) {
      removeProductFromCart(gift1Key);
    }

    if (gift2Threshold > 0 && cartTotal > gift2Threshold && gift1Exist) {
      removeProductFromCart(gift1Key);
    }

    if (cartTotal < gift2Threshold && gift2Exist) {
      removeProductFromCart(gift2Key);
    }
    if (gift3Threshold > 0 && cartTotal > gift3Threshold && gift2Exist) {
      removeProductFromCart(gift2Key);
    }
    if (cartTotal < gift3Threshold && gift3Exist) {
      removeProductFromCart(gift3Key);
    }
  };

  document.addEventListener("check-gift-products:init", checkGiftProducts);
}

class CouponCode extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.couponCodeElement = this.querySelector('[js-coupon-code]');
    this.copyButton = this.querySelector('[js-coupon-code-btn]');

    const couponCode = this.couponCodeElement.getAttribute('data-coupon-code') || '';

    if (this.copyButton) {
      this.copyButton.addEventListener('click', () => {
        this.copyToClipboard(couponCode);
      });
    }
  }

  copyToClipboard(text) {
    navigator.clipboard.writeText(text)
      .then(() => {
        if (this.copyButton) {
          this.copyButton.textContent = "Code copied";
          setTimeout(() => {
            this.copyButton.textContent = "Copy code";
          }, 2000);
        }
      })
      .catch(err => {
        console.error('Failed to copy coupon code: ', err);
      });
  }
}

customElements.define('coupon-code', CouponCode);

// function initMainCartScroll() {
//   const mainCart = document.querySelector("[js-main-cart]");
//   if (!mainCart) return;

//   const cartFooter = document.querySelector("[data-cart-footer]");
//   let lastScrollTop = 0;

//   mainCart.addEventListener("scroll", function () {
//     const currentScrollTop = mainCart.scrollTop;

//     if (currentScrollTop > lastScrollTop) {
//       cartFooter.classList.add("is-scroll-down");
//     } else {
//       cartFooter.classList.remove("is-scroll-down");
//     }

//     lastScrollTop = currentScrollTop;
//   });
// }

// initMainCartScroll();

function initMainCartScroll() {
  const mainCart = document.querySelector("[js-main-cart]");
  if (!mainCart) return;

  let lastScrollTop = 0;
  let ticking = false;

  mainCart.addEventListener("scroll", function () {
    if (!ticking) {
      requestAnimationFrame(() => {
        const currentScrollTop = mainCart.scrollTop;
        const scrollHideElements = document.querySelectorAll(".scroll-down-hide");

        if (currentScrollTop > lastScrollTop + 5) { // Scrolling down
          scrollHideElements.forEach(el => el.classList.add("hidden-data-drawer"));
        } else if (currentScrollTop < lastScrollTop - 5 && currentScrollTop > 10) { 
          // Scrolling up but NOT at the top
          scrollHideElements.forEach(el => el.classList.remove("hidden-data-drawer"));
        }

        // Only update lastScrollTop if not at the very top
        if (currentScrollTop > 0) {
          lastScrollTop = currentScrollTop;
        }

        ticking = false;
      });

      ticking = true;
    }
  });
}

initMainCartScroll();

